/*
 * Renew25 LP — configurable tracking pixels.
 *
 * Reads window.NT_RENEW25_PIXELS_URL (assets/renew25-pixels.json, published by the
 * nt-skin-config app's "Pixels" tab) and injects each pixel's raw header snippet
 * into <head>, exactly as the vendor supplied it (Meta Pixel, GA gtag, etc).
 *
 * These are raw page-level tags — NOT Shopify Web Pixels. The store's native pixel
 * manager is bound to the main store, so this LP gets its own tags this way.
 *
 * Config shape:
 *   { "pixels": [ { "label": "...", "script": "<!-- ... --><script>...</script>" }, ... ] }
 *
 * Non-blocking and fail-safe: a missing/empty/404 config injects nothing.
 *
 * NOTE: scripts inserted via innerHTML do NOT execute per the HTML spec, so each
 * <script> in a snippet is re-created as a live element. Snippet order is preserved.
 */
(function () {
  var url = window.NT_RENEW25_PIXELS_URL;
  if (!url) return;

  // Current page handle (set by the shared head snippet): 'index' for the homepage,
  // the page/product/collection handle otherwise.
  var handle = (window.NT_RENEW25_PAGE_HANDLE || '').toString().trim().toLowerCase();

  fetch(url)
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cfg) {
      var pixels = (cfg && Array.isArray(cfg.pixels)) ? cfg.pixels : [];
      // Registered page handles; a pixel that isn't "all pages" fires only on these.
      var registered = (cfg && Array.isArray(cfg.pages)) ? cfg.pages : [];
      pixels.forEach(function (p) {
        if (!p || p.enabled === false || !p.script || !String(p.script).trim()) return;
        var applies = p.allPages === true || (handle && registered.indexOf(handle) !== -1);
        if (applies) injectSnippet(String(p.script));
      });
    })
    .catch(function () { /* no tracking rather than a broken page */ });

  // Parse an HTML snippet and append its nodes to <head>, re-creating <script>
  // elements so they actually run. Inline and external (src) scripts both execute,
  // in document order; <noscript>/comments are appended harmlessly.
  function injectSnippet(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var head = document.head || document.getElementsByTagName('head')[0];

    Array.prototype.slice.call(tmp.childNodes).forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === 'SCRIPT') {
        var s = document.createElement('script');
        for (var i = 0; i < node.attributes.length; i++) {
          var a = node.attributes[i];
          s.setAttribute(a.name, a.value);
        }
        if (node.textContent) s.appendChild(document.createTextNode(node.textContent));
        head.appendChild(s);
      } else {
        head.appendChild(node);
      }
    });
  }
})();
